/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type {
  NoPayOrderPageList,
  PayedOrderPageList,
  OrderDetail,
  ComprehensivePageList,
  ComprehensiveViewDetails
} from './types';

enum Api {
  noPayOrderPageList = '/front-end/order-manager/supplier/paymentCenter/orderManagement/noPayOrderPageList', // 未完结订单列表
  submitList = '/front-end/order-manager/supplier/paymentCenter/orderManagement/submit/list', // 发起支付(提交订单)-列表查询
  paySubmit = '/front-end/order-manager/supplier/paymentCenter/orderManagement/submit', // 发起支付(提交订单)
  viewDetails = '/front-end/order-manager/supplier/paymentCenter/orderManagement/project/viewDetails', // 查看明细(项目服务费订单)
  removePerson = '/front-end/order-manager/supplier/paymentCenter/orderManagement/removePeople', // 移除人员
  payedOrderPageList = '/front-end/order-manager/supplier/paymentCenter/orderManagement/payedOrderPageList', // 已完结订单列表

  comprehensivePageList = '/front-end/order-manager/supplier/paymentCenter/orderManagement/comprehensive/payedOrderPageList', // 查询订单列表(综合服务费)
  comprehensiveViewDetails = '/front-end/order-manager/supplier/paymentCenter/orderManagement/comprehensive/viewDetails', // 查看明细(综合服务费)

  getVerifyCodeApi = '/front-end/order-manager/supplier/paymentCenter/orderManagement/sendSms', // 获取手机号验证码（发短信）
  operatorInfo = '/front-end/order-manager/supplier/paymentCenter/orderManagement/operatorInfo' // 发短信-查询经办人电话
}
export const paySubmit = async (params: {
  verifyCode?: string;
  idList: number[];
}) =>
  http.request({
    url: Api.paySubmit,
    method: 'POST',
    params
  });
export const operatorInfo = async (params: {
  t: number;
}): Promise<
  Result<{
    phone: string;
  }>
> =>
  http.request({
    url: Api.operatorInfo,
    method: 'POST',
    params
  });
export const comprehensivePageList: ComprehensivePageList = params => {
  return http.request({
    url: Api.comprehensivePageList,
    method: 'POST',
    params
  });
};
export const comprehensiveViewDetails: ComprehensiveViewDetails = params => {
  return http.request({
    url: Api.comprehensiveViewDetails,
    method: 'POST',
    params
  });
};

export const viewDetails: OrderDetail = params => {
  return http.request({
    url: Api.viewDetails,
    method: 'POST',
    params
  });
};

export const noPayOrderPageList: NoPayOrderPageList = params =>
  http.request({
    url: Api.noPayOrderPageList,
    method: 'POST',
    params
  });

export const payedOrderPageList: PayedOrderPageList = params =>
  http.request({
    url: Api.payedOrderPageList,
    method: 'POST',
    params
  });

export const removePerson = async (params: { idList: number[] }) =>
  http.request({
    url: Api.removePerson,
    method: 'POST',
    params
  });

export const submitList = async (params: {
  supplierOrderIdList: number[];
}): Promise<
  Result<{
    projectServiceOrderNum: number; //项目服务费订单数量
    terminalSettlementAmount: number; //终端结算金额（分）
    comprehensiveServiceFeeOrderNum: number; //关联综合服务费订单数量
    comprehensiveServiceFeeAmount: number; //综合服务费订单金额(分)
    totalAmount: number; //共计金额
    dataList: {
      id: number;
      orderNo: string; //订单编号
      orderTime: string; //订单生成时间 格式：时间戳
      orderType: string; //订单类型: 1-项目服务费 2-综合服务费
      projectName: string; //项目名称
      customerName: string; //客户名称
      supplierPayType: string; //供应商付款方式: 1-线上  2-线下
      payPassagewayCode: string; //交易支付通道编号
      payPassagewayName: string; //交易支付通道名称
      terminalSettlementAmount: string; //终端结算金额（分）
    }[];
  }>
> =>
  http.request({
    url: Api.submitList,
    method: 'POST',
    params
  });

export const getVerifyCodeApi = async params =>
  http.request({
    url: Api.getVerifyCodeApi,
    method: 'POST',
    params
  });
